@let message = (message$ | async) ?? '';

@if (message.length > 0) {
  <div
    #container
    class="system-notification"
    [class.marquee]="isOverflowing()"
    [style.--animation-duration]="animationDuration()"
  >
    <span #content class="system-notification__text">
      {{ message }}
    </span>
  </div>
}
